var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.7,
    height: 112.111,
    viewBox: "0 0 107.7 112.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.063,
    y1: -0.271,
    x2: 0,
    y2: 1.327,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e95cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b6ee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-1342.87 -630.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M1409.568,665.976a30.8,30.8,0,0,1,30.769,30.77,30.463,30.463,0,0,1-2.9,12.973l-10.227,17.8h-35.28l-10.229-17.8a30.462,30.462,0,0,1-2.9-12.969,30.8,30.8,0,0,1,30.769-30.77m0-3.046a33.758,33.758,0,0,0-30.574,48.194l11.171,19.439h38.806l11.167-19.434a33.757,33.757,0,0,0-30.571-48.2Z",
    transform: "translate(-12.848 -12.848)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M1435.16,780.757V783.9a5.463,5.463,0,0,1-2.728,4.72l-7.784,4.487-1.5.866-.021,1.565c-.312.372-1.685,1.221-4.123,1.264h-.026l-.069,0-.138,0a6.4,6.4,0,0,1-4.231-1.246l.088-1.694-1.644-.927-7.719-4.35a5.455,5.455,0,0,1-2.773-4.746v-3.087h32.67m3.046-3.046h-38.763v6.133a8.494,8.494,0,0,0,4.324,7.4l7.72,4.35c0,.04-.011.08-.011.12,0,2.286,3.29,4.14,7.349,4.14.071,0,.14,0,.21-.006l.011.006.012-.007c3.931-.069,7.084-1.874,7.113-4.1l7.784-4.487a8.5,8.5,0,0,0,4.252-7.36v-6.188Z",
    transform: "translate(-22.104 -57.695)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1342.87 682.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M1356.975,718.977h-12.582a1.523,1.523,0,1,1,0-3.046h12.582a1.523,1.523,0,0,1,0,3.046Z",
    transform: "translate(-1342.87 -715.931)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(1434.942 682.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M1508.091,718.977h-12.582a1.523,1.523,0,0,1,0-3.046h12.582a1.523,1.523,0,1,1,0,3.046Z",
    transform: "translate(-1493.986 -715.931)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1358.196 645.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M1378.444,667.146a1.519,1.519,0,0,1-1.076-.446l-8.9-8.9a1.523,1.523,0,1,1,2.154-2.154l8.9,8.9a1.523,1.523,0,0,1-1.077,2.6Z",
    transform: "translate(-1368.024 -655.203)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(1423.301 710.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M1485.3,774a1.517,1.517,0,0,1-1.077-.447l-8.9-8.9a1.523,1.523,0,0,1,2.154-2.154l8.9,8.9a1.524,1.524,0,0,1-1.077,2.6Z",
    transform: "translate(-1474.879 -762.057)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(1358.196 710.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M1369.547,774a1.524,1.524,0,0,1-1.077-2.6l8.9-8.9a1.523,1.523,0,1,1,2.154,2.154l-8.9,8.9A1.517,1.517,0,0,1,1369.547,774Z",
    transform: "translate(-1368.024 -762.057)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(1423.301 645.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M1476.4,667.146a1.523,1.523,0,0,1-1.077-2.6l8.9-8.9a1.523,1.523,0,0,1,2.154,2.154l-8.9,8.9A1.519,1.519,0,0,1,1476.4,667.146Z",
    transform: "translate(-1474.879 -655.203)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(1395.197 630.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M1430.276,645.677a1.523,1.523,0,0,1-1.523-1.523V631.571a1.523,1.523,0,1,1,3.046,0v12.582A1.523,1.523,0,0,1,1430.276,645.677Z",
    transform: "translate(-1428.753 -630.048)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.46689b01b27543c65842c386339cce9d.svg";
export { ForwardRef as ReactComponent };